<div [@routeAnimations]="prepareRoute(o)">
  <ng-container *ngIf="loadingRoute">
    <div class="absolute top-0 left-0 right-0">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-container>
  
  <ngx-loading-bar color="#0E97C1" height='4px'></ngx-loading-bar>
  <!-- <app-custom-loader></app-custom-loader> -->
  <router-outlet #o="outlet"/>
</div>
